import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
class ShareInfoApi extends Requestor {
    getShareInfo(hubId = '', params = {}) {
        return this.get({
            url: `/api/v1/hubs/${hubId}/shares`,
            params,
        });
    }
    getShareInfoConfig(hubId = '', agencyHubId = '') {
        return this.get({
            url: `/api/v1/hubs/${hubId}/shares/${agencyHubId}`,
        });
    }
    postShareInfoConfig(hubId = '', data = {}) {
        return this.post({
            url: `/api/v1/hubs/${hubId}/shares`,
            data,
        });
    }
}
export default new ShareInfoApi(clientInstance);
